export default __webpack_public_path__ + "static/media/sokoj-banner-autori.dbf3780a.jpg";